module.exports = __webpack_public_path__ + "img/1.15_Russian_road_sign.dcd721ca.svg";